<template>
    <footer class="footer">
        <!-- Footer Top Start -->
        <div class="footer-sec">
            <div class="container">
                <div class="row">
                    <!-- Single Footer Widget Start -->
                    <div class="col-md-4 col-sm-6 footer-widget">
                        <div class="footer-wedget-one">
                            <a class="footer-logo" href="index.html"><img src="images/ft-logo.png" alt=""/></a>
                            <div class="footer-wedget-contact">
                                <!--<div class="footer-social-profile">-->
                                <!--<ul>-->
                                <!--<li><a href=""><i class="fa fa-facebook"></i></a></li>-->
                                <!--<li><a href=""><i class="fa fa-twitter"></i></a></li>-->
                                <!--<li><a href=""><i class="fa fa-google"></i></a></li>-->
                                <!--<li><a href=""><i class="fa fa-skype"></i></a></li>-->
                                <!--</ul>-->
                                <!--</div>-->
                                <div class="inner-box">
                                    <div class="media">
                                        <div class="inner-item">
                                            <div class="media-left">
                                                    <span class="icon">
                                                        <i class="fa fa-map" aria-hidden="true"></i>
                                                    </span>
                                            </div>
                                            <div class="media-body">
                                                <span class="inner-text text-white">Rr. K. Karafili P. 14 H. 24 Ap. 14 - Tirana</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="media">
                                        <div class="inner-item">
                                            <div class="media-left">
                                                <span class="icon"><i class="fa fa-envelope-o"></i></span>
                                            </div>
                                            <div class="media-body">
                                                <span class="inner-text ">
                                                    <a class="text-white"
                                                       href="mailto:agron@lamaj.de">agron@lamaj.de</a>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="media">
                                        <div class="inner-item">
                                            <div class="media-left">
                                                <span class="icon"><i class="fa fa-phone"></i></span>
                                            </div>
                                            <div class="media-body">
                                                <span class="inner-text text-white">
                                                    <a class="text-white" href="tel:+355674898004">+355 67 48 98 004</a>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-8 col-sm-6 footer-widget text-md-right">
                        <div class="footer-wedget-one">
                            <h1 style="margin-bottom: 35px;" class="text-white">Partner</h1>
                            <div class="footer-wedget-contact">
                                <div class="inner-item">
                                    <div class="media-body">
                                        <a class="footer-logo d-inline mr-20" target="_blank" href="http://bbw-consulting.net/">
                                            <img src="images/partners/BBW-Consulting.png" width="150px" alt=""/>
                                        </a>
                                        <a class="footer-logo d-inline my-5" target="_blank" href="http://bbw-consulting.net/">
                                            <img src="images/partners/BBW-Unternehmensberatung.jpg" width="150px"
                                                 alt=""/>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Single Footer Widget End -->
                </div>
            </div>
        </div>
        <!-- Footer Top End -->
        <!-- Footer Bottom Start -->
        <div class="footer-bottom-sec">
            <div class="container">
                <div class="row">
                    <div class="col-md-12 col-sm-12">
                        <div class="copy-right">
                            <p>© {{year}} Lamaj Consulting</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Footer Bottom End -->
    </footer>
</template>

<script>
    export default {
        name: 'Footer',
        data() {
           return {
               year: new Date().getFullYear()
           }
        }
    };
</script>
